import {Component, Input} from "@angular/core";
import {Job} from "../shared/job.model";

@Component({
  selector: 'app-job-details-header',
  templateUrl: 'job-details-header.component.html',

})
export class JobDetailsHeaderComponent {
  @Input('job') job: Job;
}



// WEBPACK FOOTER //
// ./src/pages/job/job-details-header/job-details-header.component.ts